import { Component, ElementRef, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { LanguageService } from './../../core/services/language.service';
import { FADE_IN_OUT_ANIMATION } from './../../shared/animations/animations';
import { ClickedOutsideDirective } from './../../shared/directives/clicked-outside.directive';

@Component({
    selector: 'gl-languages',
    templateUrl: './languages.component.html',
    styleUrls: ['./languages.component.scss'],
    animations: [FADE_IN_OUT_ANIMATION],
    standalone: false
})
export class LanguagesComponent extends ClickedOutsideDirective {
  public languages: string[];
  public isOpen: boolean;
  constructor(
    elRef: ElementRef,
    private languageService: LanguageService,
    private translate: TranslateService,
    private navigationService: NavigationService
  ) {
    super(elRef);
    this.languages = this.languageService.languages;
  }

  @HostListener('clickedOutside') public onClickedOutisde() {
    this.closeList();
  }

  public getCurrentLanguage() {
    return this.translate.currentLang;
  }

  public toggleList() {
    this.languages = this.languageService.languages.filter(
      language => language !== this.translate.currentLang
    );
    this.isOpen = !this.isOpen;
  }

  public changeLanguage(language) {
    this.languageService
      .setLanguage(language)
      .subscribe(() =>
        this.navigationService.changeLanguageInCurrentRoute(language)
      );
    this.closeList();
  }

  private closeList() {
    this.isOpen = false;
  }
}
